<script setup lang="ts">
import { ref } from 'vue';
import debounce from 'debounce';

const props = defineProps({
    debounceTimer: {
        type: Number,
        default: 1000
    },
    placeholder: {
        type: String,
        // TODO Localize
        default: 'Search...'
    },
    disabled: {
        type: Boolean,
        default: false
    },
    modelValue: {
        type: String,
        default: ''
    },
    iconOnly: {
        type: Boolean,
        default: false
    }
});

const searchTerm = ref(props.modelValue);

const emit = defineEmits(['update:modelValue']);

const handleInput = debounce((value: string) => {
    emit('update:modelValue', value);
}, props.debounceTimer);

const clear = () => {
    searchTerm.value = '';
    handleInput('');
};

watch(() => props.modelValue, (newValue) => {
    searchTerm.value = newValue;
}, { immediate: true });
</script>

<template>
    <VLIconField>
        <VLInputText
            v-bind="$attrs"
            v-model="searchTerm"
            type="text"
            :class="iconOnly && 'responsive-search'"
            :placeholder="placeholder"
            :disabled="disabled"
            @input="handleInput(searchTerm)"
        />
        <VLInputIcon v-if="!searchTerm">
            <i class="pi pi-search" />
        </VLInputIcon>

        <VLInputIcon v-if="searchTerm" @click="clear()">
            <i class="pi pi-times" />
        </VLInputIcon>
    </VLIconField>
</template>

<style scoped lang="css">
.search-input {
    width: 250px;
}

.responsive-search {
    width: 10px;

    &:focus {
        width: 200px;
        transition: width 0.3s ease;
    }
}

:deep(.p-inputtext) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
